import React from "react";
import { Card, Box, Divider } from "@bca/ui-library";

import Skeleton from "../Skeleton";

const BidNowBuyNowSkeleton: React.FunctionComponent<{}> = () => {
  const screenLowerThan1024 =
    typeof window !== "undefined" ? window.innerWidth <= 1024 : false;

  return (
    <Card
      width={["100%", "60%", 650]}
      height="auto"
      paddingX={0}
      paddingY={0}
      marginX={0}
      marginY={0}
    >
      <Box
        display="flex"
        width="100%"
        height="100%"
        flexDirection={["column", "column", "row"]}
        justifyContent="space-between"
      >
        <Box m={28}>
          <Box
            height="100%"
            display="flex"
            flexDirection={["row", "row", "column"]}
            alignItems={["center", "center", "flex-start"]}
            justifyContent="space-between"
          >
            <Box display="flex" flexDirection="column">
              <Skeleton variant="text" mt={0} mb={3} width={70} height={22} />
              <Box
                display="flex"
                alignItems="flex-start"
                flexDirection="column"
              >
                <Skeleton
                  variant="text"
                  mt={0}
                  mb={3}
                  mr={12}
                  width={108}
                  height={30}
                />
                <Skeleton
                  variant="text"
                  mt={0}
                  mb={[0, 0, 3]}
                  width={63}
                  height={16}
                />
              </Box>
            </Box>
            <Skeleton variant="text" m={0} width={127} height={48} />
          </Box>
        </Box>
        <Divider
          orientation={screenLowerThan1024 ? "horizontal" : "vertical"}
          width={screenLowerThan1024 ? "100%" : "1px"}
          marginBottom={0}
          marginTop={0}
          marginLeft={0}
          marginRight={0}
        />
        <Box m={28}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Skeleton mt={0} mb={2} variant="text" width={90} height={18} />
            <Skeleton variant="text" height={18} width={66} />
          </Box>
          <Box display="flex" alignItems="center" mb={4}>
            <Skeleton variant="text" m={0} mr={4} width={92} height={35} />
            <Skeleton variant="text" height={26} width={116} />
          </Box>
          <Box display="flex" mb={3}>
            <Skeleton m={0} variant="text" width={38} height={14} />
            <Divider
              orientation="vertical"
              width="1px"
              marginTop={0}
              marginBottom={0}
              marginLeft={3}
              marginRight={3}
            />
            <Skeleton m={0} variant="text" width={106} height={14} />
          </Box>
          <Box
            display="flex"
            flexDirection={["column", "row"]}
            justifyContent="space-between"
          >
            <Box width={["auto", "50%", 200]} mb={[3, 0]}>
              <Skeleton variant="text" width="100%" height={48} />
            </Box>
            <Skeleton
              width={["auto", 150, 147]}
              variant="text"
              ml={[0, 0, 4]}
              height={48}
            />
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default BidNowBuyNowSkeleton;
